import { render, staticRenderFns } from "./identityMaterials.vue?vue&type=template&id=122f7ac1&scoped=true"
import script from "./identityMaterials.vue?vue&type=script&lang=js"
export * from "./identityMaterials.vue?vue&type=script&lang=js"
import style0 from "./identityMaterials.vue?vue&type=style&index=0&id=122f7ac1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122f7ac1",
  null
  
)

export default component.exports